import Keycloak from 'keycloak-js'
import keycloakConfig from './config/keycloak'

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak(keycloakConfig)


export default keycloak